import { useMediaQuery } from '@mui/material';
/**
 * Returns true if browser window width is less than 600px. Same as `theme.breakpoints.down('sm')`.
 * Used by `GlobalApp` to control menu and pinned bar visibility.
 */
export function useSmallDevice() {
    return useMediaQuery((theme) => theme.breakpoints.down('sm'), { noSsr: true });
}
